import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { HTMLNodeTreeWalker } from "../graphs/HTMLNodeTreeWalker";
import { ExtendedRegex } from "../text/ExtendedRegex";
import { Lexer } from "../text/lexer/Lexer";
import { LexerMatcher } from "../text/lexer/LexerMatcher";
import { SVGTextLexer, SVGTextLexerType } from "./SVGTextLexer";
import { FontInfo } from "../fonts/FontInfo";
import { FontDescription } from "../fonts/FontDescription";
import { FontLibrary } from "../fonts/FontLibrary";
import { SVGEditor } from "./SVGEditor";
import { ElementType } from "../dom-tools/ElementType";

export class SVGTextAtom
{
  text:string;
  width:number;
  type:SVGTextLexerType
}

export class SVGTextFragment
{
  lineBreak = false;
  text = "";
  href:string = null;
  atoms:SVGTextAtom[] = [];

  computeTextAtoms( fontInfo:FontInfo, fontSize:number )
  {

    let wsRegex = /(\s|\n|\r)+/;

    let compactText = this.text.replace( wsRegex, " " );
    

    let lexer = new SVGTextLexer();
    let types = lexer.lexToList( compactText );


    types.forEach(
      ( t )=>
      {
        if ( t.isError || t.isDone ){ return; }

        let atom = new SVGTextAtom();
        atom.type = t.type as SVGTextLexerType;
        
        if ( SVGTextLexer.SPACE === t.type )
        {
          atom.text = " ";
        }
        else
        {
          atom.text = t.getMatch( compactText ); 
        }

        atom.width = fontInfo.getWidth( atom.text, fontSize );

        this.atoms.push( atom );
      }
    )
  }
}
